export default "__VITE_ASSET__fe834c17__"